import find from 'lodash/find';

import { getRgbArrayFromString, getRgbStringFromArray } from '~/services/util';
import { getGeometryFromTransform, getTransformFromGeometry } from '~src/Node/nodePosition';

type TCss = 'number' | 'string' | 'color' | 'geometry';
interface ICssToFury {
    fury: string
    css: string
    type: TCss
}

export const CSS_TO_FURY: ICssToFury[] = [
    {
        fury: 'border', css: 'border-width', type: 'number'
    },
    {
        fury: 'borderColor', css: 'border-color', type: 'color'
    },
    {
        fury: 'outlineWidth', css: '-webkit-text-stroke-width', type: 'number'
    },
    {
        fury: 'outlineColor', css: '-webkit-text-stroke-color', type: 'color'
    },
    {
        fury: 'radius', css: 'border-radius', type: 'number'
    },
    {
        fury: 'fontStyle', css: 'font-style', type: 'string'
    },
    {
        fury: 'fontWeight', css: 'font-weight', type: 'string'
    },
    {
        fury: 'textAlign', css: 'text-align', type: 'string'
    },
    {
        fury: 'padding', css: 'padding', type: 'number'
    },
    {
        fury: 'fontFamily', css: 'font-family', type: 'string'
    },
    {
        fury: 'fontSize', css: 'font-size', type: 'number'
    },
    {
        fury: 'lineHeight', css: 'line-height', type: 'number'
    },
    {
        fury: 'textDecoration', css: 'text-decoration-line', type: 'string'
    },
    {
        fury: 'color', css: 'color', type: 'color'
    },
    {
        fury: 'backgroundColor', css: 'background-color', type: 'color'
    },
    {
        fury: 'geometry', css: 'transform', type: 'geometry'
    },
];

export const furyToCss = (furyName: string, value) => {
    const cf = find(CSS_TO_FURY, (f) => f.fury === furyName);
    let cssValue = null;
    if (value !== null) {
        if (cf.type === 'number' && value) {
            if (furyName === 'fontSize') cssValue = `${value.toString()}vw`;
            else cssValue = `${value.toString()}px`;
        }

        if (cf.type === 'string') cssValue = value;
        if (cf.type === 'color') cssValue = getRgbStringFromArray(value);
        if (cf.type === 'geometry') cssValue = getTransformFromGeometry(value);
    }
    return cssValue;
};

export const cssToFury = (cssName: string, value) => {
    const cf = find(CSS_TO_FURY, (f) => f.fury === cssName);
    let furyValue = null;
    if (value !== null) {
        if (cf.type === 'geometry') furyValue = getGeometryFromTransform(value, true);
        if (cf.type === 'number') furyValue = parseFloat(value) || 0;
        if (cf.type === 'string') furyValue = value || '';
        if (cf.type === 'color') furyValue = getRgbArrayFromString(value);
    }
    return furyValue;
};
